import React from 'react'
import { Layout } from 'antd'

import logoFooter from '../img/logoFooter.png'
import call from '../img/call-answer.png'
import facebook from '../img/facebook.png'
import instagram from '../img/instagram.png'

import {
  Footercomponents, FooterIconcomponents, FooterContestcomponents, FooterMapcomponents,
} from './styled-components/footerStyled'

const { Footer } = Layout

function FooterContainer() {
  return (
    <Footer style={{ backgroundColor: 'rgba(0,0,0,.8)' }}>
      <Footercomponents>
        <FooterIconcomponents>
          <img src={logoFooter} style={{ width: '250px' }} alt="logoFooter" />
        </FooterIconcomponents>
        <FooterContestcomponents>
          <p style={{
            color: '#f9a11f', fontWeight: 'bold', fontSize: '36px', lineHeight: 'unset', marginBottom: '10px',
          }}
          >Contact us
          </p>
          <p style={{ color: '#f9a11f', fontWeight: 'bold', fontSize: '20px' }}>Address</p>
          <p style={{ color: '#f9a11f' }}>โครงการ Stadium One เลขที่ 793 ถนน พระราม 6 </p>
          <p style={{ color: '#f9a11f' }}>แขวง วังใหม่ เขต ปทุมวัน กรุงเทพมหานคร 10330</p>
          <p style={{ color: '#f9a11f' }}> <img src={call} style={{ width: '13px', marginRight: '9px' }} alt="call" /> 02-163-4554</p>
          <p style={{ color: '#f9a11f' }}>
            <a href="https://www.facebook.com/thaidotrun/">
              <img src={facebook} style={{ marginRight: '9px', maxWidth: '100%', width: '25px' }} alt="facebook" />
            </a>
            <a href="https://www.instagram.com/thai.run/">
              <img src={instagram} style={{ marginRight: '9px', maxWidth: '100%', width: '25px' }} alt="instagram" />
            </a>
          </p>
        </FooterContestcomponents>
        <FooterMapcomponents>
          <iframe
            title="Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.533170800416!2d100.52183021483046!3d13.746689590350828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x34d19b0abbdd3821!2sThaidotrun%20Co.%2C%20Ltd.!5e0!3m2!1sth!2sth!4v1574616804064!5m2!1sth!2sth"
            style={{
              border: '0', width: '400px', height: '250px', frameborder: '0', allowfullscreen: '',
            }}
          />
        </FooterMapcomponents>
      </Footercomponents>
    </Footer>
  )
}

export default FooterContainer



// WEBPACK FOOTER //
// ./src/components/footer.js